import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "helpers/common";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/crm/deals";  
const apiFeedBackEndPoint=API_BASE_URL_ENV() + "/crm/feedbacks"; 
const Cilapi=API_BASE_URL_ENV() +"/crm/deals/send-cil" 
const avililabilityApi=API_BASE_URL_ENV() +"/crm/deals/send-check-availability" 

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
    addFeedback=(data)=>{
        return http.post(apiFeedBackEndPoint, data);
    }
    sendCil=(id,data)=>{
        return http.post(`${Cilapi}/${id}`, data);

    }
    checkAvililability=(id)=>{
        return  http.post(`${avililabilityApi}/${id}`);
    }

    submitRecepit = (id) =>{
        const url = API_BASE_URL_ENV()+ `/crm/deal-reciept/${id}/Submit`
        return http.get(url);
    }
    notSubmitRecepit = (id) =>{
        const url = API_BASE_URL_ENV()+ `/crm/deal-reciept/${id}/Not-Submit`
        return http.get(url);
    }
    sendMessage= (data) => {
        const url = API_BASE_URL_ENV()+ `/crm/send-message`
        return http.post(url, data);
    }
}
